<!-- 水果行情 -->
<template>
<div class="info-block">
  <router-link :to="'/sghq/hqDetail/'+info.id" class="info-block-a">
    <div class="div-1">
      <div class="div-1-1">{{info.name}}</div>
      <div class="div-1-4">
        <table class="div-1-4-table" cellpadding="2" cellspacing="0" >
          <tr>
            <td class="td-title location-ico">产地：{{info.dependency}}</td>
            <td class="td-title1 first-child">近期价格</td>
            <td class="td-title1">周涨跌幅</td>
            <td class="td-title1">月涨跌幅</td>
          </tr>
          <tr>
            <td class="td-title data-ico">时间：{{info.create_time}}</td>
            <td class="td-value1">{{info.price}}<span>{{info.daily_change}}</span></td>
            <td class="td-value2">{{info.weekly_change}}<span>+---%</span></td>
            <td class="td-value3">{{info.monthly_change}}<span>---%</span></td>
          </tr>
        </table>
      </div>
      <div class="div-3">
        <router-link :to="{path: '/sghqDetail'}" class="td-action-1">
          了解详情
        </router-link>
      </div>
    </div>


  </router-link>
</div>
</template>

<script>
export default {
  name: 'JghqInfo',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:120px;
  padding:0px;
  margin:0px 1px 20px 0px;
  background-color:#FBFCFC;
  border:1px solid #ddd;
  background-size: 200px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  //box-shadow:0px 0px 1px 1px orange;
}

.div-1{
  position:relative;
  height:100%;
  width:100%;
  padding:0px 150px 0px 10px;
  //background:#fff;

}

.div-1-1{
  position:relative;
  height:30px;
  //background:red;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#000;
  padding:10px 10px 1px 0px;
}

.div-1-4{
  position:relative;
  height:80px;
  //background:green;
  text-align:left;
  color:#bbb;
  padding:10px 0px 10px 0px;
}

.div-1-4-table{
  width:100%;
}

.div-1-4-table .td-title{
  height:30px;
  width:260px;
  text-align:left;
  color:#888;
  line-height:30px;
  padding-left:15px;
}

.div-1-4-table .td-value{

  text-align:left;
  font-size:12px;
  line-height:15px;
  color:#bbb;
}

.div-1-4-table .td-title1{
  text-align:left;
  color:#4E4F4F;
  padding-left:10px;
  border-left:1px solid #bbb;
}

.div-1-4-table .first-child{
  border-left:0px solid #000;
}


.div-1-4-table .td-value1{
  text-align:left;
  font-size:16px;
  font-weight:600;
  line-height:35px;
  padding-left:10px;
  color:var(--color2);
}

.div-1-4-table .td-value1 span{
  text-align:left;
  padding-left:5px;
  font-weight:500;
  color:#F40A0A;
}

.div-1-4-table .td-value2{
  text-align:left;
  font-size:16px;
  font-weight:600;
  line-height:35px;
  color:var(--color2);
  padding-left:10px;
  border-left:1px solid #bbb;
}

.div-1-4-table .td-value2 span{
  text-align:left;
  padding-left:5px;
  font-weight:500;
  color:var(--color1);
}

.div-1-4-table .td-value3{
  text-align:left;
  font-size:16px;
  font-weight:600;
  line-height:35px;
  color:var(--color3);
  padding-left:10px;
  border-left:1px solid #bbb;
}

.div-1-4-table .td-value3 span{
  text-align:left;
  padding-left:5px;
  font-weight:500;
  color:var(--color1);
}

.data-ico{
  background-image:url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 10px;
}

.location-ico{
  background-image:url(./../../assets/location.png);
  background-size: 17px 17px;
  background-repeat: no-repeat;
  background-position: -1px 7px;
}


.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:100px;
  margin:15px 20px 15px 0px;
  padding-left:10px;
  //background:yellow;
}

.div-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:40px;
  border:1px solid var(--color7);
  color:#000;
  line-height:20px;
  text-align:center;
}

.div-3 .td-action-1:hover{
  color:#fff;
  background:var(--color7);
}


.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/JghqInfo.vue